import React, { useContext } from 'react';
import { styled } from '@mui/material';

import { Box, Container, Logo, Stack } from 'shell/components';
import { PageContext } from '../PageProvider';
import LoginInputs from 'components/organisms/Login/LoginInputs';
import { useViewport } from 'contexts/viewport';

const Tablet = () => {
    const { device } = useViewport();
    const { country, errors, form, handleChange, handleClickButton, COUNTRY_OPTIONS } = useContext(PageContext);
    return (
        <BackgroundBox>
            <Container device={device}>
                <CenterBox>
                    <Stack alignItems={'center'}>
                        <Logo device={'desktop'} />
                    </Stack>
                    <LoginInputs
                        country={country}
                        errors={errors}
                        device={device}
                        form={form}
                        handleChange={handleChange}
                        handleClickButton={handleClickButton}
                        COUNTRY_OPTIONS={COUNTRY_OPTIONS}
                    />
                </CenterBox>
            </Container>
        </BackgroundBox>
    );
};

const BackgroundBox = styled(Box)(({ theme }) => {
    return {
        width: '100vw',
        height: '100%',
        background: theme.palette.ensightful.neutral[50],
    };
});

const CenterBox = styled(Box)(({ theme }) => {
    return {
        paddingTop: theme.spacing(18),
        width: 'fit-content',
        height: '100%',
    };
});

export default Tablet;
